var _path, _path2, _line, _line2, _line3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1064 7.86203V12.3532H1.89209V7.86203C1.89209 5.31757 3.95478 3.25488 6.49923 3.25488C9.04369 3.25488 11.1064 5.31757 11.1064 7.86203Z",
    fill: "white",
    stroke: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74193 8.26289C3.74193 8.26289 3.40068 6.05221 5.10693 5.50879",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.99951,
    y1: 1.33594,
    x2: 5.99951,
    y2: 0.499872,
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 1.34303,
    y2: -0.5,
    transform: "matrix(0.577944 -0.816077 0.822192 0.56921 8.35498 2.42383)",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 1.34303,
    y2: -0.5,
    transform: "matrix(0.577988 0.816045 -0.822223 0.569166 2.78467 0.918945)",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99951 10.8281H10.9995C11.8279 10.8281 12.4995 11.4997 12.4995 12.3281V13.5003H0.499512V12.3281C0.499512 11.4997 1.17108 10.8281 1.99951 10.8281Z",
    fill: "white",
    stroke: "#A3A3A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/icon__report.50529cfb2717ef3815fbd062dea156a8.svg";
export { ForwardRef as ReactComponent };